// Abonnement aux fonctions IA : état, paiement Stripe (Checkout, portail), retour de paiement.
window.abonnementEtat = { info: null, chargement: false, erreur: '', retour: null };
window.chargerAbonnement = function(cb) {
    window.abonnementEtat.chargement = true;
    window.syncWithServer('abonnement_info', {}, function(d) {
        window.abonnementEtat.chargement = false;
        if (d && d.success) window.abonnementEtat.info = d.abonnement; else window.abonnementEtat.erreur = (d && d.message) || '';
        window.renderContent(); if (cb) cb(d);
    });
};
window.actions.stripeCheckout = function(plan) {
    var e = window.abonnementEtat; e.erreur = ''; e.chargement = true; window.renderContent();
    window.syncWithServer('stripe_checkout', { plan: plan || 'mensuel' }, function(d) {
        if (d && d.success && d.url) { location.assign(d.url); return; }
        e.chargement = false; e.erreur = (d && d.message) || 'Impossible d\'ouvrir le paiement.'; window.renderContent();
    });
};
window.actions.stripePortal = function() {
    var e = window.abonnementEtat; e.erreur = ''; e.chargement = true; window.renderContent();
    window.syncWithServer('stripe_portal', {}, function(d) {
        if (d && d.success && d.url) { location.assign(d.url); return; }
        e.chargement = false; e.erreur = (d && d.message) || 'Portail indisponible.'; window.renderContent();
    });
};
window.abonnementRetour = function() {
    var q = new URLSearchParams(location.search), sid = q.get('session_id');
    if (sid) {
        window.abonnementEtat.retour = 'verification';
        window.syncWithServer('stripe_sync', { session_id: sid }, function(d) {
            window.abonnementEtat.retour = (d && d.success && d.paye) ? 'ok' : 'attente';
            if (d && d.success) window.abonnementEtat.info = d.abonnement;
            try { history.replaceState(null, '', location.pathname); } catch (e) {}
            window.chargerMoi(); window.renderContent();
        });
    } else if (q.get('annule')) { window.abonnementEtat.retour = 'annule'; try { history.replaceState(null, '', location.pathname); } catch (e) {} }
};
window.euros = function(cents) { return (Math.round(cents) / 100).toLocaleString('fr-FR', { style: 'currency', currency: 'EUR' }); };

// Exports : les mêmes fonctions que celles posées sur window (le code historique les lit encore là).
export const abonnementEtat = window.abonnementEtat;
export const chargerAbonnement = window.chargerAbonnement;
export const abonnementRetour = window.abonnementRetour;
export const euros = window.euros;
